module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-radio-group', {
    staticClass: "lmr_category",
    attrs: {
      "row": true
    },
    on: {
      "change": _vm.changeValue
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Infos locales",
      "value": "general"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Sports",
      "value": "sport"
    }
  }), _vm._v(" "), (this.$parent.consumer_group == 'ebra') ? _c('v-radio', {
    attrs: {
      "label": "Magazine",
      "value": "magazine"
    }
  }) : _vm._e(), _vm._v(" "), (this.$store.state.consumerName == 'lng') ? _c('v-radio', {
    attrs: {
      "label": "Faits Divers",
      "value": "faits_divers"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$t('all'),
      "value": ""
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0959c10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marker/record/LmrCategoryFilter.vue
// module id = 1069
// module chunks = 1